import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

const BadgeDisplay = ({ badges }) => {
  const unlockedCount = badges.filter(b => b.unlocked).length;

  return (
    <Card className="backdrop-blur-sm bg-white/90 border-emerald-200 shadow-xl mt-8" data-testid="badge-display">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="text-2xl text-emerald-900">Badges</CardTitle>
          <Badge variant="secondary" className="bg-emerald-100 text-emerald-700 text-sm">
            {unlockedCount} / {badges.length} Unlocked
          </Badge>
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {badges.map((badge, index) => (
            <div
              key={index}
              data-testid={`badge-${index}`}
              className={`p-4 rounded-2xl text-center transition-all duration-300 ${
                badge.unlocked
                  ? 'bg-gradient-to-br from-emerald-400 to-teal-500 shadow-lg shadow-emerald-200 transform hover:scale-105'
                  : 'bg-gray-100 opacity-50'
              }`}
            >
              <div className="text-4xl mb-2">
                {badge.unlocked ? badge.icon : '🔒'}
              </div>
              <div className={`font-semibold text-sm mb-1 ${
                badge.unlocked ? 'text-white' : 'text-gray-500'
              }`}>
                {badge.name}
              </div>
              <div className={`text-xs ${
                badge.unlocked ? 'text-emerald-50' : 'text-gray-400'
              }`}>
                {badge.hours}h
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default BadgeDisplay;